module.exports = __webpack_public_path__ + "media/images/gallery/7s-79482ab211bf0cbe7a2dcad6803d7ff3.jpg";